/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Retail {

    import fld = GiftVoucherAllocateDetailsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class GiftVoucherAllocateDetailsEditor extends Common.GridEditorBase<GiftVoucherAllocateDetailsRow> {


        protected getColumnsKey() { return "Retail.GiftVoucherAllocateDetails"; }
        protected getDialogType() { return GiftVoucherAllocateDetailsDialog; }
        protected getLocalTextPrefix() { return GiftVoucherAllocateDetailsRow.localTextPrefix; }
        protected form: GiftVoucherAllocateDetailsForm;

        private pendingChanges: Q.Dictionary<any> = {};
        public CompanyId: number;
        public EmployeeId: number;
        constructor(container: JQuery) {
            super(container);

        }
        protected getButtons() {
            let buttons = super.getButtons();
            //var grid = OMS.ProductSelectGrid;
            buttons.pop();
            buttons.push({
                title: "Select Vouchers",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var grid = GiftVoucherItemDetailsSelectGrid;
                    // **** Validate Party before Item Selection ****
                    //if (isNaN(this.PartyId)) {
                    //    Q.notifyWarning("Please select Supplier to proceed");
                    //    return;

                    //}
                    //else {
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.TransItemId)
                    });
                    //}

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems;//.filter(t => { return !Q.any(this.view.getItems(), n => n.TransItemId == t.TransItemId) });
                        var self = this;
                        var items = [];
                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: GiftVoucherItemDetailsRow) {


                            var Exchange: GiftVoucherAllocateDetailsRow = {
                                Amount: value.Amount,
                                Code: value.Code,
                                CompanyId: self.CompanyId,
                                EmployeeId: self.EmployeeId,
                                GvMasterId: value.GiftMasterId,
                                GvNumber: value.UniqueNo,
                                RefTransId: value.TransId,
                                RefTransItemId: value.Id,
                                Value: value.Value,
                                UserId: Q.Authorization.userDefinition.UserId,
                               
                            };

                            items.push(Exchange);

                        });

                        for (let item of items) {
                            item[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(item);
                        }



                        // #endregion
                    }

                    pickerDialog.dialogOpen();
                }
            });


            return buttons;
        }
    }
}